import AxiosService from "./axios-service";
import CONFIG from "../helpers/app";

export const getAxiosClient = () => {
  return new AxiosService({
    axios: {
      baseURL: CONFIG.API_URL,
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    },
  });
};
